<template>
  <md-card class="md-card-stats">
    <md-card-header class="md-card-header-icon" :class="getClass(headerColor)">
      <slot name="header"></slot>
    </md-card-header>

    <div class="footer-wrapper">
      <md-card-actions :md-alignment="footerFloat">
        <slot name="footer"></slot>
      </md-card-actions>
    </div>
  </md-card>
</template>
<script>
export default {
  name: "stats-card",
  props: {
    headerColor: {
      type: String,
      default: ""
    },
    footerFloat:{
      type: String,
      default: "left"
    }
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    }
  }
};
</script>
<style scoped lang="scss">
.footer-wrapper {
  margin-top: 5px;
  min-height: 40px;
}
</style>